import Contract from "slotworks/utils/contracts/contract";

export default class Parallel<T> extends Contract<T> {

    private resolve: (value: T) => any;
    private count: number;

    private childContracts: Array<Contract<any>>;

    constructor(private methods: Array<() => Contract<any>>) {
        super((resolve) => {
            this.count = this.methods.length;

            this.resolve = resolve;

            if (!this.count) {
                this.resolve(null);
            }

            this.childContracts = [];

            for (const method of this.methods) {
                const childContract = method();
                this.childContracts.push(childContract);

                childContract.then((result?: T) => {
                    this.count--;

                    if (this.count <= 0) {
                        resolve(result);
                    }
                });
            }
        });
    }

    public cancel() {
        super.cancel();

        for (const childContract of this.childContracts) {
            childContract.cancel();
        }
    }

    public forceResolve() {
        super.forceResolve();

        for (const childContract of this.childContracts) {
            childContract.cancel();
        }
    }
}
